import { useEffect } from 'react';
import ContentLoader from './components/ContentLoader/ContentLoader';
import createAppStateStore from './app-state-store';
import { cetraLightModeTheme } from './theme';
import { observer } from 'mobx-react-lite';
import UnauthenticatedAppWithStore from './react-core-lib/components/app/unauthenticated-app-with-store';
import mixpanel from 'mixpanel-browser';
import config from './config';
import './App.css';
import './console-overrides';

function App() {

  useEffect(() => {
    console.log('App::useEffect');

    const { clinicType, isProd, mixpanelToken } = config;

    if (mixpanelToken) {
      mixpanel.init(mixpanelToken, {
        api_host: 'https://api-eu.mixpanel.com',
        persistence: 'localStorage',
        ignore_dnt: true,
      });
      console.log(`[Patient UI] Mixpanel initialized for ${clinicType} (${isProd ? 'prod' : 'dev'})`);
    }
  }, []);

  return (    
    <UnauthenticatedAppWithStore      
      UnauthenticatedComponent={ContentLoader}
      createAppStateStore={createAppStateStore}
      theme={cetraLightModeTheme}
      globalComponents={<></>}
    />
  );
}

export default observer(App);
